<template>
  <div
    class="mx-auto flex flex-col gap-12 max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8"
  >
    <div
      class="flex flex-col gap-y-8 rounded-xl shadow-sm mx-auto w-full py-16 px-4 sm:py-12 sm:px-8"
      :style="backgroundStyle"
    >
      <div
        class="flex flex-col w-full mx-auto justify-center items-center max-w-[800px] text-center"
      >
        <h1
          class="text-pretty text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-balance"
        >
          Get in touch
        </h1>
        <p
          class="mt-4 text-lg sm:text-xl sm:leading-[30px] text-white text-pretty sm:mt-2"
        >
          We are here to help you. If you have any questions, feel
          free to reach out to us.
        </p>
      </div>

      <div class="flex justify-center w-full">
        <Button
          size="default"
          variant="secondary"
          class="w-full text-base text-gray-700 font-semibold text-center px-[18px] py-3 sm:w-fit"
          @click="showDemoDialog = true"
        >
          Book a demo
          <ArrowRightIcon class="!size-5 stroke-2" />
        </Button>
      </div>
    </div>

    <BookDemoDialog v-model:show="showDemoDialog" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import Button from "@/Components/ui/button/Button.vue";
import BookDemoDialog from "@/Components/Welcome/BookDemoDialog.vue";
import ctaBackground from "@/../images/cta-background.svg";
import { ArrowRightIcon } from "@heroicons/vue/24/outline";
import { useBreakpoints } from "@vueuse/core";

const showDemoDialog = ref(false);

const breakpoints = useBreakpoints({
    mobile: 0,
    tablet: 640,
    laptop: 1024,
    desktop: 1280,
});

const isMobile = breakpoints.between("mobile", "tablet");

const backgroundStyle = computed(() =>
    isMobile.value
        ? {
              background:
                  "linear-gradient(63.44deg, #53389E 16.72%, #7F56D9 83.39%)",
          }
        : {
              backgroundImage: `url(${ctaBackground})`,
          }
);
</script>
